import {Box} from '@chakra-ui/react'
import Logo from '@app/components/Logo'
import {Flex, Text} from '@chakra-ui/react'
import {Link} from '@inertiajs/react'

const links = [
  {
    label: 'Inicio',
    url: '/',
  },
  {
    label: 'Política de privacidad',
    url: '/privacy-policy',
  },
]

type HeaderProps = Record<string, never>

export default function Header(props: HeaderProps) {
  return (
    <Flex
      alignItems="center"
      as="header"
      height="20"
      justifyContent="space-between"
    >
      <Logo height="16" />

      <Box hideBelow="md">
        <Flex>
          {links.map((link) => (
            <Text
              key={link.url}
              fontSize="sm"
              fontWeight="semibold"
              padding="4"
              color={
                window.location.pathname === link.url ? 'brand' : 'gray.500'
              }
              asChild
            >
              <Link href={link.url}>{link.label}</Link>
            </Text>
          ))}
        </Flex>
      </Box>
    </Flex>
  )
}
